// extracted by mini-css-extract-plugin
export var filterIncDec = "_f4-0";
export var leftBorder = "_f4-1";
export var rightBorder = "_f4-2";
export var stringInput = "_f4-3";